// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import {
  DeclarativeContent,
  DeclarativeItemBase,
} from "./DeclarativeContentTypes";
import React, { memo } from "react";

import DeclarativeItemRenderer from "./DeclarativeItemRenderer";
import { ReactNode } from "react";
import { uuid } from "uuidv4";

interface DeclarativeContentRendererProps {
  contentDescription: DeclarativeContent;
  [propName: string]: any;
}

/**
 * Use to render an array of Declarative items in a test run step.
 */
export default memo((props: DeclarativeContentRendererProps) => {
  const { contentDescription } = props;
  const uniqueId = uuid();
  return (
    <>
      {contentDescription.map(
        (item: DeclarativeItemBase, index: number): ReactNode => {
          const key = item.type + "_" + index + "_" + uniqueId;

          return <DeclarativeItemRenderer item={item} key={key} />;
        }
      )}
    </>
  );
});
